<template>
  <v-app id="inspire">

    <v-main style="background-color: #24292d;font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container fluid fill-height align-start>
        <v-row>
          <v-col md="3" lg="3" cols="6">
            <v-card color="#393E46">
              <v-card-title>
                Eventos
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col md="12" lg="12" cols="12">

                    <v-autocomplete v-model="eventoId" :items="eventos" item-text="nombre" item-value="id" @change="dameInscritos" label="Escoger Evento">
                    </v-autocomplete>
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col md="3" lg="3" cols="6">
            <v-card color="#393E46">
              <v-card-title>
                Bajar Excel
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col md="12" lg="12" cols="12">
                    <vue-excel-xlsx
                        class   = "btn"
                        :data="personas"
                        :columns="columns"
                        :filename="'Socios'"

                    >
                      <v-btn v-if="diexcel" style="background-color: #6D9886;"> Bajar Excel</v-btn>
                    </vue-excel-xlsx>
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row  >
          <v-col md="12" lg="12" cols="12">
            <v-alert
                :value="alerterror"
                color="red"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              {{texterror}}
            </v-alert>
            <v-alert
                :value="alertborrador"
                color="red"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su inscritos se borro con éxito.
            </v-alert>
            <v-alert
                :value="alertnuevo"
                color="primary"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su inscritos se agrego con éxito.
            </v-alert>
            <v-alert
                :value="alerteditar"
                color="green"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su inscritos se edito con éxito.
            </v-alert>
            <v-data-table
                :headers="headers"
                :items="inscritos"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                :search="search"
                disable-sort
                item-key="id"
                show-expand
                :loading="progr"
                no-data-text="No hay datos disponibles para mostrar."
                no-results-text="No hay resultados para la búsqueda."
                loading-text="Cargando... Por favor espere."
                style="background-color: #393E46;"
            >
              <template v-slot:top>
                <v-toolbar flat >
                  <v-toolbar-title>Inscritos</v-toolbar-title>
                  <v-btn @click="dameInscritos"><v-icon>fas fa-sync-alt</v-icon></v-btn>

                  <v-divider
                      class="mx-4"
                      inset
                      vertical
                  ></v-divider>
                  <v-text-field v-model="search" @change="dameInscritos" label="Buscar" class="mx-4"></v-text-field>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="6" sm="6" md="6">
                              <v-text-field v-model="editedItem.persona.nombrePersona" label="Nombre"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-text-field v-model="editedItem.persona.personaApellidoPaterno" label="Apellido Paterno"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-text-field v-model="editedItem.persona.personaApellidoMaterno" label="Apellido Materno"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-text-field type="number" v-model="editedItem.persona.personaTelefono" label="Telefono"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-text-field  v-model="editedItem.persona.personaDireccion" label="Direccion"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-autocomplete  v-model="editedItem.persona.personaDistrito" :items="distritos" item-value="id" item-text="distrito" persistent-hint
                                               hint="distrito"
                                               single-line label="Escoger Distrito"></v-autocomplete>
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-autocomplete  v-model="editedItem.persona.personaSexo" :items="sexos" item-value="sexoId" item-text="sexo" hint="Sexo" persistent-hint
                                               return-object
                                               single-line label="Escoger Sexo"></v-autocomplete>
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-menu
                                  ref="menu1"
                                  v-model="menu1"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="editedItem.persona.personaFechaNacimiento" label="Fecha"
                                                hint="YYYY-MM-DD" persistent-hint
                                                @blur="date = formatDatee(editedItem.persona.personaFechaNacimiento)"
                                                v-on="on"
                                                :formatter="format"
                                                prepend-icon="fas fa-calendar" ></v-text-field></template>
                                <v-date-picker
                                    v-model="date"
                                    no-title
                                    min="1950-01-01"
                                    @input="menu1 = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>

                            <v-col cols="6" sm="6" md="6">
                              <v-text-field  v-model="editedItem.referido" label="Referido"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogdelete" persistent max-width="350">
                    <v-card>
                      <v-card-title class="headline">Desea eliminar esta inscritos?</v-card-title>
                      <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="close">No</v-btn>
                        <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>




                </v-toolbar>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    color="error"
                    class="mr-2"
                    @click="deleteItem(item)"
                >
                  fas fa-minus-circle
                </v-icon>


              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="dameInscritos">Cargar de Nuevo</v-btn>
              </template>
              <template v-slot:[`item.persona.fechaNacimientoPersona`]="{ item }">
                {{formatFecha(item.persona.fechaNacimientoPersona)}}
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td class="pa-4" :colspan="headers.length">
                  <v-row cols="1">
                    <v-col md="3" lg="3" >
                      <v-img :src="item.persona.fotoPersona" contain height="200px"    width="200px"        @click="zoomItem(item)"
                      />
                    </v-col>
                    <v-col md="5" lg="5" >
                      <v-row>
                        <v-col md="12" lg="12" >
                          {{item.persona.nombrePersona}}  DNI: {{item.persona.dniPersona}}
                        </v-col>
                        <v-col md="12" lg="12">
                          {{item.persona.emailPersona}} - {{item.persona.telefonoPersona}}
                        </v-col>
                        <v-col md="12" lg="12">
                          {{item.persona.direccionPersona}} - {{item.persona.distritoPersona}}
                        </v-col>

                      </v-row>
                    </v-col>
                    <v-col md="3" lg="3" >
                      <vue-qr :text="item.codigoUnico" :size="200" />
                    </v-col>
                  </v-row>
                </td>

              </template>
            </v-data-table>

          </v-col>
        </v-row>

        <leftmenujuegos :abreviado="abreviado" />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>
<style>
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>
<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import VueQr from 'vue-qr'
import moment from "moment";
import Leftmenujuegos from "@/components/general/leftmenujuegos";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Inscritos | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    Leftmenujuegos,
    VueQr
  },
  data: () => ({
    drawer: null,
    idnegocio: 0,
    negociotg:[],
    eventoId: 0,
    token:'',
    progr: true,
    diexcel: false,
    overlay: false,
    singleExpand: true,
    expanded:[],
    alertborrador: false,
    alertnuevo: false,
    alerteditar: false,
    alerterror:false,
    texterror:'',
    dialog: false,
    columns : [
      {
        label: "Nombre",
        field: "nombre",
      },
      {
        label: "DNI",
        field: "dni",
      },
      {
        label: "Telefono",
        field: "telefono",
      },
      {
        label: "Email",
        field: "email",
      },
      {
        label: "Direccion",
        field: "direccion",
      },
      {
        label: "Referencia1",
        field: "ref1",
      },
      {
        label: "Referencia2",
        field: "ref2",
      },
      {
        label: "FechaRegistro",
        field: "createdAt",
      }
    ],
    dialogdelete: false,
    dialogimage: false,
    dialoguploadimage: false,
    dialoguploadimagedni: false,
    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    inscritos: [],
    pagina: 1,
    cantidad: 0,
    tamanio: 10,
    categoriaEventoId:0,
    imagen:null,
    personas:[],
    distritos: [{id:0,distrito:"Escoger Distrito",ciudad:{}}],
    estadoseventos: [],
    eventos: [],
    abreviado:'NN',

    search: '',
    editedIndex: -1,
    editedItem: {
      id:0,
      createdAt: null,
      persona: {},
      tipoPago: {},
      eventoEntrada : {},
      contacto: {},
      banco:{},
      nrooper:'',
      voucher: '',
      fechaIngreso: null,
      transferido:false,
      referencia:'',
      estadoEvento:{},
      bebida: '',
      nacionalidad:'',
      puesto:'',
      codigoUnico:''
    },
    defaultItem: {
      id:0,
      createdAt: null,
      persona: {},
      tipoPago: {},
      eventoEntrada : {},
      contacto: {},
      banco:{},
      nrooper:'',
      voucher: '',
      fechaIngreso: null,
      transferido:false,
      referencia:'',
      estadoEvento:{},
      bebida: '',
      nacionalidad:'',
      puesto:'',
      codigoUnico:''
    },
    headers: [
      { text: '', value: 'data-table-expand', sortable: false },
      { text: 'Acciones', value: 'action', sortable: false },
      { text: 'Premio', value: 'premioNombre' },
      { text: 'Nombre', align: 'left',  value: 'persona.nombrePersona'},
      { text: 'DNI', value: 'persona.dniPersona' },
      { text: 'Fecha y Hora', value: 'createdAt' }
    ]
  }),
  mounted (){

    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false

              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.dameEventos();
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })

    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.dameEventos();
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    date () {
      this.editedItem.fechaNacimiento = this.formatDatee(this.date)
    },
    eventoId(){
      this.dameInscritos()
    }
  },
  methods : {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatFecha(value) {
      return moment(value).locale('es-pe').format("DD/MM/YYYY")
    },
    format(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    dameInscritos(){
      this.progr = true;
      this.overlay = true;

      axios
          .get('inscripciones/juego/'+this.eventoId,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.inscritos = response.data;

            this.personas = [];
            response.data.forEach((entry)=>{

              let obj = {
                nombre : entry.persona.nombrePersona,
                dni: entry.persona.dniPersona,
                email : entry.persona.emailPersona,
                direccion: entry.persona.direccionPersona,
                distrito : entry.persona.distritoPersona,
                telefono : entry.persona.telefonoPersona,
                ref1: entry.persona.ref1Persona,
                ref2: entry.persona.ref2Persona,
                createdAt: entry.createdAt
              }

              this.personas.push(obj)
            });

            this.diexcel = true
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false

          })
          .catch((error)  => {
            this.overlay = false
            this.alerterror = true
            this.texterror = 'inscritos: '+error
            this.progr = false;
          });
    },

    dameEventos(){

      let urltempor = 'juegos/cliente/' + this.cliente.id  ;
      this.diexcel = false;
      this.overlay = true

      axios
          .get(urltempor,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.eventos = response.data;
            this.eventoId = this.eventos[0].id
            this.dameInscritos();
            this.overlay = false

          })
          .catch((error)  => {
            this.alerterror = true
            this.texterror = 'Eventos: '+error
            this.overlay = false

          });
    },
    editItem (item) {
      this.editedIndex = this.inscritos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.persona.personaFechaNacimiento = this.formatDatee(this.editedItem.persona.personaFechaNacimiento)
      this.dialog = true
    },


    deleteItem (item) {
      this.editedIndex = this.inscritos.indexOf(item);
      this.dialogdelete = true;
    },
    borralo (){
      axios
          .delete('tickets/ticket/'+this.inscritos[this.editedIndex].id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.log(response);
            this.dialogdelete = false;
            this.alertborrador = true;
            this.dameInscritos();
          })
          .catch(error => {
            this.error = "Hubo un error";
            this.alerterror = true
            this.texterror = error
          });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.inscritos[this.editedIndex], this.editedItem);
        var bodyFormData = new FormData();
        bodyFormData.append("data",JSON.stringify(this.editedItem));
        axios
            .post('historiainscritos/editar',bodyFormData,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            }).then(response => {
              console.info(response)
          this.alerteditar = true;
          this.dameInscritos();
        })
            .catch(error => {
              this.error = "Hubo un error";
              this.alerterror = true
              this.texterror = error
            });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Socio' : 'Editar Socio'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      cliente:"cliente",
      sexos:"sexos"
    })
  }
};
</script>
